import request from "../request";

export function getWebsiteArticle(payload) {
	return request.get({
		url: `/website/websiteArticle/home`,
	});
}

export function getLogoList(payload) {
	return request.get({
		url: `/website/logo/list`,
	});
}
